import React from "react";
import { CustomInputText } from "../../CustomInputText";
import { CustomButtonsForm } from "../../CustomButtonsForm";
import { useForm, Controller } from "react-hook-form";
import { CustomInputSwitch } from "../../CustomInputSwitch";

export const CreateChannelForm = (props) => {

    const { action } = props;
    const { handleSubmit, control, formState: { errors } } = useForm();

    return (
        <form style={{ margin: '30px 30px 20px 30px', position: 'relative',  width: 420 }} onSubmit={ handleSubmit(action) }>
            <div style={{ height: '60%' }}>

                <Controller 
                    name='canal'
                    control={ control }
                    defaultValue=''
                    render={({ field: { onChange, value } }) => (
                        <CustomInputText
                            label="Canal"
                            placeholder=""
                            error={ errors?.canal } 
                            onChange={ onChange }
                            value={ value }
                        />
                    )}
                    
                    rules={{ 
                        required: 'El campo es obligatorio.'
                    }}
                />

                <Controller 
                    name='interno'
                    control={ control }
                    defaultValue={false}
                    render={({ field: { onChange, value } }) => (
                        <CustomInputSwitch
                            label="¿Es presencial?"
                            onChange={ onChange }
                            value={ value }
                        />
                    )}
                />
            </div>

            <CustomButtonsForm name='Crear' />
        </form>
    );
};